import { Link } from "react-router-dom";
import { Play, Pause } from "lucide-react";
import { motion } from "framer-motion";
import { usePlayer } from "../context/AudioContext";
import { resolveMedia } from "../lib/api";

export const VaultCard = ({ entry, index = 0 }) => {
  const { playTrack, track, playing } = usePlayer();
  const isCurrent = track?.slug === entry.slug;

  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay: index * 0.12, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/vault/${entry.slug}`}
        data-testid={`vault-card-${entry.slug}`}
        className="group block border border-gold/15 hover:border-gold/50 bg-gallery transition-colors duration-500"
      >
        <div className="relative overflow-hidden aspect-[4/5]">
          {entry.artwork_url ? (
            <img
              src={resolveMedia(entry.artwork_url)}
              alt={entry.title}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full bg-velvet flex items-center justify-center">
              <span className="font-serif italic text-gold/40 text-xl">Queen Denae</span>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-transparent to-transparent" />
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              playTrack({ ...entry, tag: "The Royal Vault" });
            }}
            data-testid={`vault-card-play-btn-${entry.slug}`}
            aria-label={`Play ${entry.title}`}
            className="absolute bottom-5 left-5 w-12 h-12 rounded-full bg-gold text-obsidian flex items-center justify-center hover:bg-goldglow transition-colors duration-300 shadow-lg shadow-black/50"
          >
            {isCurrent && playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
          </button>
          <span className="absolute top-5 left-5 font-mono text-[10px] tracking-[0.3em] uppercase text-goldglow bg-obsidian/70 backdrop-blur px-3 py-1.5">
            From the Royal Vault
          </span>
        </div>
        <div className="p-6">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold/70">{entry.category}</p>
          <h3 className="mt-2 font-serif text-2xl text-cream group-hover:text-goldglow transition-colors duration-300">
            {entry.title}
          </h3>
          {entry.description && (
            <p className="mt-2 text-sm text-sand leading-relaxed line-clamp-2">{entry.description}</p>
          )}
          <p className="mt-4 font-mono text-[10px] tracking-[0.25em] uppercase text-sand/50 group-hover:text-gold transition-colors duration-300">
            Enter the Vault →
          </p>
        </div>
      </Link>
    </motion.div>
  );
};
